import { jsx } from "react/jsx-runtime";
import { MarkdownRenderer } from "@nxt-costco-com/forge-components";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import { SameDay } from "./SameDay.js";
import { markdownStyles } from "./styles.js";
const cleanupMarkdownHTML = (markdown) => {
  if (markdown.startsWith("<")) {
    return markdown.replace(/[\n\t]+[\s]*/gi, " ");
  }
  return markdown;
};
function Markdown({ entry }) {
  if (!entry) {
    console.error("Markdown error: Invalid entry.");
    return null;
  }
  const { markdown } = entry;
  const cleanedMarkdown = cleanupMarkdownHTML(markdown);
  return /* @__PURE__ */ jsx(CostcoBox, { sx: markdownStyles, children: /* @__PURE__ */ jsx(
    MarkdownRenderer,
    {
      overrides: {
        SameDay: {
          component: SameDay
        }
      },
      markdown: cleanedMarkdown
    }
  ) });
}
export {
  Markdown
};
